<template>
  <input
    class="input-contact__item"
    :type="type"
    :name="name"
    :value="value"
    :placeholder="placeholder"
    :required="isRequired"
  />
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "text",
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      required: true,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.input-contact {
  &__item {
    position: relative;
    height: 70px;
    width: 100%;
    padding: 0 25px;
    background: var(--color-white);
    border: 1px solid var(--color-gray-2);
    border-radius: 10px;
    font-size: 25px;
    font-family: "Font Regular";
    margin-bottom: 40px;
    @media (max-width: 991px) {
      height: 50px;
      border: 1px solid var(--color-black);
      padding: 0 10px;
      border-radius: 10px;
      margin-bottom: 20px;
    }
  }
}
</style>
